import {AllergenResponse} from "@/types/service-response";


export default class Allergen {
  private constructor(
      readonly id: string,
      readonly description: string | null,
      readonly shortTitle: string,
      readonly code: string,
      readonly createdAt: string,
      readonly title: string
  ) {
  }


  public static createFromResponse(response: AllergenResponse[]): Allergen[] {
    return response.map((item: AllergenResponse) => {
      return new Allergen(
        item.id,
        item.description,
        item.shortTitle,
        item.code,
        item.createdAt,
        item.title)
    })
  }

  get iri (): string {
    return `/api/food-database/allergen/${this.id}`
  }
}